<template>
  <div v-loading="loading" element-loading-text="拼命加载中" style="height: 100%;">
    <el-table :data="tableData" style="width: 100%" height="calc(100% - 70px)">
      <el-table-column prop="customer_name" label="类型" align="center" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type==='TO_N'" type="danger" effect="plain">取消年框</el-tag>
          <el-tag v-else type="warning" effect="plain">申请年框</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <span v-if="MapStatusShow[scope.row.status]" :style="`color:${MapStatusShow[scope.row.status].color}`">
            {{ MapStatusShow[scope.row.status].label }}
          </span>
          <span v-else>未知</span>
        </template>
      </el-table-column>
      <el-table-column prop="customer_name" label="开拓者" align="center" width="80">
        <template slot-scope="scope">
          {{ scope.row.customer && scope.row.customer.pioneer_name ? scope.row.customer.pioneer_name : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="销售" align="center" width="80"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          {{ Array.isArray(scope.row.then_sales) ? scope.row.then_sales.join('、') : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="creator" label="申请人" align="center" width="110"/>
      <el-table-column prop="sign_begin" label="签约开始" align="center" width="110" sortable/>
      <el-table-column prop="sign_end" label="签约截至" align="center" width="110" sortable/>
      <el-table-column prop="policy_alias" label="年框政策" min-width="120" align="center" show-overflow-tooltip/>
      <el-table-column prop="pay_method" label="付款方式" align="center" min-width="100" show-overflow-tooltip>
        <template slot-scope="{row}">
          {{ row.pay_method && row.pay_method_sub ? row.pay_method + '-' + row.pay_method_sub : row.pay_method }}
        </template>
      </el-table-column>
      <el-table-column prop="charge_person" label="最高级别负责人" align="center" min-width="100"/>
      <el-table-column prop="post" label="职位" align="center" min-width="100"/>
      <el-table-column prop="created_at" label="申请时间" align="center" width="135" sortable/>
      <el-table-column label="说明" min-width="110" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.creator_remark">申请人：{{ scope.row.creator_remark }}；&nbsp;</span>
          <span v-if="scope.row.audit_remark">审核人：{{ scope.row.audit_remark }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        :current-page="queryParams.page"
        :page-size="queryParams.page_size"
        layout="prev, pager, next"
        :total="queryParams.total"
        @current-change="handleCurrentChange"
        style="margin-top: 10px"
    />
  </div>
</template>

<script>
import {yearFrameList} from "@/api/customerYearFrame";

const MapStatus = {
  WAIT: 0,
  PASS: 1,
  REJECT: 2,
  CANCEL: 3,
}
const MapStatusShow = {
  [MapStatus.WAIT]: {label: '待审核', color: '#409eff'},
  [MapStatus.PASS]: {label: `通\u3000过`, color: '#67c23a'},
  [MapStatus.REJECT]: {label: '拒\u3000绝', color: '#f56c6c'},
  [MapStatus.CANCEL]: {label: '撤\u3000回', color: '#909399'},
}
export default {
  name: "table-apply",
  props: {
    customerId: {
      type: [String, Number],
      required: true
    },
  },
  data() {
    return {
      MapStatusShow,
      loading: false,
      tableData: [],
      queryParams: {
        customer_id: [this.customerId],
        page: 1,
        page_size: 10,
        total: 0,
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.getTableData()
      this.loading = false
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getTableData()
    },
    async getTableData() {
      const response = await yearFrameList(this.queryParams)
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }

      const array = response.model.data || [];
      array.map(datum => {
        datum.vue_audit = datum.status
        datum.vue_audit_remark = null
      })
      this.queryParams.total = response.model.total
      this.tableData = array;
    },
  }
}
</script>

<style scoped>

</style>